import Dexie from "dexie";
import Cookies from "js-cookie";
import { roundWithTolerance, roundDecimals } from "../utils/formatNumbers";
import { getModels } from "./config";
import {
  anotarAvisoDeProceso,
  anotarError,
  anotarErrorDeProceso,
  anotarProceso,
  entidadDeTabla,
} from "../services/syncLog";

// Crear instancia de la base de datos
const db = new Dexie("exceliaoneDB");

/**
 * Definición base del esquema de tablas
 * Cada migración futura puede extender este objeto.
 */
const schemaBase = {
  users:
    "++id, No, username, email, [firstName+lastName], pendingSync, lastModified, lastSynced, deleted, Admin",
  clients:
    "++id, No, name, Tipo_Documento_SrI, Numero_Identificacion_fiscal, Customer_Price_Group, Telefono, Mobil, E_Mail, Direccion, Direccion_2, Poblacion, Cod_Postal, Pais, Contacto, POS_Discount, createdAt, lastModified, lastSynced, pendingSync, deleted, Source_Counter",
  clientAddresses: "++id, CustomerNo, Code, Name, Ciudad, Provincia, Email, Teléfono, lastSynced",
  products:
    "++id, No, description, Unit_Price, barcode, PorIva, pendingSync, lastModified, lastSynced, deleted",
  invoices:
    "++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, E_Mail, Telefono, Mobil, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, Payment_Method, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime",
  invoiceLines:
    "++id, invoiceId, invoiceNo, Line_No, Type, No, Description, Quantity, Unit_Price, Line_Discount_, PorIva, pendingSync, lastModified, lastSynced, deleted",
  invoicePaymentLines:
    "++id, invoiceId, Line_No, Document_Type, Document_No_, Payment_Method, Amount, pendingSync, lastModified, lastSynced, deleted",
  productLines:
    "++id, No, Line_No, Parent_Item_No, Type, Description, Quantity_per, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
  formasPago: "++id, No, Code, Description, Dto, Tipo_Pago, lastSynced",
  turnos:
    "++id, DescripcionTurno, No, HorarioInicio, HorarioFin, pendingSync, lastModified, lastSynced, deleted",
  aperturaDeCaja:
    "++id, No, Cajero, FechaDeApertura, HoraDeApertura, ImporteDeApertura, Estado, Turno, Caja, pendingSync, lastModified, lastSynced, deleted",
  cajas: "++id, No, nombre, TPV, tpvNombre, pendingSync, lastModified, lastSynced, deleted",
  cierreDeCaja:
    "++id, No, Cajero, ImporteDeApertura, FechaDeApertura, ImporteDeCierreBS, ImporteDeCierreUS, ImporteDeCierreEUR, ArqueoBS, ArqueoUS, ArqueoEUR, ArqueoEfectivoUS, ArqueoTarjetaUS, FechaDeCierre, Estado, idApertura, Comprobante_Tarjetas, pendingSync, lastModified, lastSynced, deleted",
  cierreDeCajaDetalle:
    "++id, cierreId, Line_No, idCierre, idApertura, idFormaPago, DesFormaPago, MontoPago, TipoPago, pendingSync, lastModified, lastSynced, deleted",
  formaDePago:
    "++id, No, CodDivisa, CodFormaPago, ImporteAplicado, Cambio, ImporteTotal, ImporteRecibido, Vuelto, DocumentNo, AccountNo, Vendedor, FechaRegistro, pendingSync, lastModified, lastSynced, deleted",
  divisas: "++id, CodDivisa, Descripcion, Simbolo, pendingSync, lastModified, lastSynced, deleted",
  colegios: "++id, No, nombre, pendingSync, lastModified, lastSynced, deleted",
  tpvs: "++id, No, nombre, direccion, direccion2, ciudad, codigoPostal, provincia, pais, telefono, movil, email, sitioWeb, nifCif, contacto, notas, fechaAlta, locationCode, noSeries, margenCierre, pendingSync, lastModified, lastSynced, deleted",
  coupons:
    "++id, No, Description, Starting_Date, Ending_Date, Status, Active, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, pendingSync, lastModified, lastSynced, deleted",
  couponSalesPrices:
    "++id, couponNo, Item_No, Unit_Price, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
  couponLineDiscounts:
    "++id, couponNo, Type, Code, Line_Discount_Percentage, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
  couponDetails:
    "++id, couponNo, Detail_Type, No, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, Status, pendingSync, lastModified, lastSynced, deleted",
  salesPrices:
    "++id, Item_No, Sales_Type, Sales_Code, Minimum_Quantity, Unit_of_Measure_Code, Starting_Date, Ending_Date, Unit_Price, Currency_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
  campaigns:
    "++id, No, Description, Starting_Date, Ending_Date, Sales_Prices, Line_Discounts, pendingSync, lastModified, lastSynced, deleted",
  empresa:
    "++id, Primary_Key, Name, Address, City, Country_Region_Code, E_Mail, VAT_Registration_No, lastSynced, lastModified",
  environment: "++id, company, env, country, apiUrl, isActive, lastModified",
  syncMetadata:
    "++id, entity, lastSyncDate, lastSuccessfulSync, totalRecords, syncStatus, errorMessage",
};

/**
 * Versión 6 - Nuevas tablas únicas Paraguay
 */
const schemaV6 = {
  ...schemaBase,
  departamentos: "++id, value, label, lastModified, lastSynced",
  distritos: "++id, value, label, lastModified, lastSynced",
  ciudades: "++id, value, label, lastModified, lastSynced",
  vendedores: "++id, value, label, lastModified, lastSynced",
};

/**
 * Versión 7 - Nuevas tablas únicas Paraguay
 */
const schemaV7 = {
  ...schemaV6,
  grupoPrecios: "++id, value, label, lastModified, lastSynced",
};

/**
 * Versión 8 - Impuestos
 */
const schemaV8 = {
  ...schemaV7,
  grupoIVA:
    "++id, VAT_Bus_Posting_Group, VAT_Prod_Posting_Group, VAT_Identifier, VAT_Percent, SRI_Tax_Code, SRI_VAT_Rate, Blocked, [VAT_Bus_Posting_Group+VAT_Prod_Posting_Group]",
};

/**
 * Versión 9 - Datos fiscales Honduras
 */
const schemaV9 = {
  ...schemaV8,
  serieNCF:
    "++id, Series_Code, No_Autorizacion_CAI, Establecimiento, Punto_de_Emision, Tipo_Comprobante, Fecha_Caducidad, Fecha_Autorizacion, lastSynced",
};

/**
 * Versión 10 - Campo Pre_Assigned_No indexado en invoices
 */
const schemaV10 = {
  ...schemaV9,
  invoices:
    "++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, E_Mail, Telefono, Mobil, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, Payment_Method, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime, Pre_Assigned_No",
};

db.version(10)
  .stores(schemaV10)
  .upgrade(() => {});

/**
 * Versión 11 - Campo Posting_Date indexado en invoices (los reportes
 * filtraban por fecha con un .filter() en JS sobre TODA la tabla, ver
 * getInvoicesByDateRange en invoiceService.js).
 */
const schemaV11 = {
  ...schemaV10,
  invoices:
    "++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, E_Mail, Telefono, Mobil, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, Payment_Method, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime, Pre_Assigned_No, Posting_Date",
};

db.version(11)
  .stores(schemaV11)
  .upgrade(() => {});

/**
 * Versión 12 - Campo Applies_to_Doc_No indexado en invoices. getCreditMemosForInvoice
 * hacía un .filter() de tabla completa cada vez; con las notas de crédito
 * parciales se llama con más frecuencia (validar al guardar, recalcular al
 * reabrir un borrador), así que vale la pena indexarlo.
 */
const schemaV12 = {
  ...schemaV11,
  invoices:
    "++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, E_Mail, Telefono, Mobil, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, Payment_Method, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime, Pre_Assigned_No, Posting_Date, Applies_to_Doc_No",
};

db.version(12)
  .stores(schemaV12)
  .upgrade(() => {});

/**
 * Versión 13 - Stock por tienda en products (sync de importaciones_getproductostock
 * al abrir caja). Agrega locationCode y el índice compuesto [No+locationCode] para
 * poder tener un mismo No de item con stock distinto por tienda en el mismo dispositivo,
 * igual patrón de índice compuesto que ya usa grupoIVA
 * ([VAT_Bus_Posting_Group+VAT_Prod_Posting_Group]).
 */
const schemaV13 = {
  ...schemaV12,
  products:
    "++id, No, description, Unit_Price, barcode, PorIva, pendingSync, lastModified, lastSynced, deleted, locationCode, [No+locationCode]",
};

db.version(13)
  .stores(schemaV13)
  .upgrade(() => {});

/**
 * Versión 14 - Catálogos de cliente para Perú: grupos de precio (todos los
 * países) y grupos de descuento (Perú), sincronizados desde BC vía
 * selectOptionService, mismo shape que grupoPrecios.
 */
const schemaV14 = {
  ...schemaV13,
  gruposPrecioCliente: "++id, value, label, lastModified, lastSynced",
  gruposDtoCliente: "++id, value, label, lastModified, lastSynced",
};

db.version(14)
  .stores(schemaV14)
  .upgrade(() => {});

/**
 * Versión 15 - Catálogo de grupos de cajero (GrupoCajeros), sincronizado
 * desde BC vía selectOptionService, mismo shape base que gruposPrecioCliente.
 * Cada registro también guarda "tienda" (BC asocia cada Grupo a una Tienda
 * puntual) como propiedad simple, sin indexar -- no hace falta filtrar por
 * ese campo todavía, pero queda disponible por si hace falta más adelante
 * (ver mapFn en selectOptionService.js). Usado en el campo "Grupo" del
 * formulario de Usuario.
 */
const schemaV15 = {
  ...schemaV14,
  grupoCajeros: "++id, value, label, lastModified, lastSynced",
};

db.version(15)
  .stores(schemaV15)
  .upgrade(() => {});

/**
 * Versión 16 - Índice compuesto [CustomerNo+Code] en clientAddresses.
 *
 * En Business Central el Code de una dirección de envío es único POR CLIENTE,
 * no globalmente: en el ambiente de Ecuador hay 16.604 clientes cuya dirección
 * tiene Code "01" (es el que BC asigna al crear un cliente). El pull indexaba
 * las direcciones locales sólo por Code, así que cada dirección con ese código
 * sobrescribía a la anterior y las 19.952 direcciones de BC terminaban en 3.343
 * filas locales, con el CustomerNo del último cliente procesado. Síntoma: el
 * ícono de direcciones aparecía vacío para casi todos los clientes.
 *
 * La tabla se vacía en el upgrade porque los datos existentes ya están
 * corrompidos por ese pisado -- se repueblan solos en la siguiente
 * sincronización.
 */
const schemaV16 = {
  ...schemaV15,
  clientAddresses:
    "++id, CustomerNo, Code, [CustomerNo+Code], Name, Ciudad, Provincia, Email, Teléfono, lastSynced",
};

db.version(16)
  .stores(schemaV16)
  .upgrade(async (tx) => {
    await tx.table("clientAddresses").clear();
  });

/**
 * Versión 17 - Catálogo de puestos (ListaPuestos), sincronizado desde BC vía
 * selectOptionService. Es el catálogo del campo "Cargo": en BC ese valor se
 * guarda como código (ej. "JEF") y el catálogo lo traduce a su descripción
 * ("JEFE"). Mismo shape base que grupoCajeros.
 */
const schemaV17 = {
  ...schemaV16,
  puestos: "++id, value, label, lastModified, lastSynced",
};

db.version(17)
  .stores(schemaV17)
  .upgrade(() => {});

/**
 * Versión 18 - Los dos apellidos del usuario se guardan por separado, como los
 * tiene Business Central.
 *
 * Antes sólo existía `lastName`, armado concatenando `First_Family_Name` y
 * `Second_Family_Name` con un espacio, y al enviar se volvía a partir por el
 * primer espacio. Eso perdía información en cuanto un apellido tenía más de una
 * palabra: medido contra el ambiente, "BUSINESS CENTRAL" | "" volvía a BC como
 * "BUSINESS" | "CENTRAL". BC guarda y devuelve los dos campos intactos; el que
 * los pegaba y los partía era el cliente.
 *
 * `lastName` se conserva como campo derivado -- lo leen diecisiete pantallas y
 * el índice de búsqueda -- pero deja de ser el origen de la verdad.
 *
 * Los campos nuevos no van indexados, así que el esquema no cambia: esta
 * versión existe sólo para poder rellenar lo que ya está guardado. El relleno
 * usa la misma partición de antes, para no cambiar lo que se enviaría hoy; la
 * primera sincronización lo corrige con los valores reales de BC.
 */
db.version(18)
  .stores(schemaV17)
  .upgrade(async (tx) => {
    await tx
      .table("users")
      .toCollection()
      .modify((user) => {
        if (user.primerApellido !== undefined) return;

        const partes = user.lastName ? user.lastName.trim().split(" ") : [];
        user.primerApellido = partes[0] || "";
        user.segundoApellido = partes.length > 1 ? partes[1] : "";
      });
  });

/**
 * Versión 19 - La venta que se está tecleando, para poder retomarla.
 *
 * Hasta ahora una venta a medias sólo existía en la memoria del navegador: si
 * se cerraba la pestaña, se reiniciaba el equipo o Windows decidía actualizarse
 * con veinticinco líneas de una lista escolar ya escaneadas, había que
 * rehacerlas una por una. El borrador (F4) cubría el caso, pero hay que
 * acordarse de pulsarlo, y quien pierde la venta es justamente quien no llegó.
 *
 * Una fila por cajero: el terminal lo comparten varias personas por turno, y a
 * nadie se le puede ofrecer retomar la venta a medias de otro. Por eso la clave
 * primaria es el `No` del cajero y no un autoincremental -- guardar es siempre
 * un `put` sobre la misma fila, sin que se acumulen restos.
 */
const schemaV19 = {
  ...schemaV17,
  ventasEnCurso: "usuario, guardadoEn",
};

db.version(19)
  .stores(schemaV19)
  .upgrade(() => {});

/**
 * Versión 20 - Qué formas de pago tiene cada tienda.
 *
 * En Business Central la cuenta contra la que se cobra no es un dato de la
 * forma de pago: es del par **(forma de pago, tienda)**, en la tabla
 * `Payment Method Det TPV`. Al registrar, `CuentaPago` busca ese par, y si no
 * lo encuentra lanza `CUENTA_PAGO_NO_CONFIGURADA` desde dentro del registro --
 * lo que deshace el `Sales-Post` entero y deja el borrador varado allá--.
 *
 * O sea que el par no es una preferencia contable: **es la condición para poder
 * cobrar con esa forma de pago en esa tienda**. Por eso el terminal necesita
 * conocerlo antes, y no enterarse al intentar registrar.
 *
 * **Tabla aparte, y no una columna en `formasPago`.** El catálogo se queda
 * entero a propósito: hace falta para *nombrar* la forma de pago de documentos
 * de otras tiendas --históricos, informes, notas de crédito sobre una venta de
 * otro local--. Si se filtrara el catálogo, esos documentos empezarían a
 * enseñar el código pelado en lugar del nombre. El filtro vive donde se
 * **elige**, no donde se nombra.
 *
 * La clave compuesta `[Tienda+FormaPago]` es la consulta real: «¿puede esta
 * tienda cobrar con esto?». El índice suelto por `Tienda` sirve a la otra:
 * «¿qué puede ofrecer esta caja?», que es la de la apertura.
 *
 * Contrato `FormasPagoTienda` con Business Central, acordado el 20/09/2026:
 * `page 75242 "Formas Pago Tienda TPV"`, dos propiedades --`FormaPago` y
 * `Tienda`--, sólo lectura por construcción. La cuenta contable se queda del
 * lado de BC a propósito: el terminal no tiene nada que hacer leyéndola.
 */
const schemaV20 = {
  ...schemaV19,
  formasPagoPorTienda: "++id, Tienda, FormaPago, [Tienda+FormaPago], lastSynced",
};

db.version(20)
  .stores(schemaV20)
  .upgrade(() => {});

/**
 * Versión 21 - Divisas de Business Central (servicio OData `Divisas`), con su
 * tipo de cambio vigente, en todos los países; ver divisaSyncService.
 *
 * Reemplaza a la `divisas` anterior (CodDivisa/Descripcion/Simbolo), que nadie
 * leía y sólo se sembraba con EUR/USD/BS fijos. Se vacía al actualizar para que
 * esas filas sembradas no se mezclen con las de BC.
 */
const schemaV21 = {
  ...schemaV20,
  divisas: "++id, Code, lastSynced",
};

db.version(21)
  .stores(schemaV21)
  .upgrade((tx) => tx.table("divisas").clear());

/**
 * Versión 22 - Productos adoptados por colegio y grado (servicio OData
 * `ProductosAdoptados`), sólo Perú; ver productoAdoptadoSyncService.
 *
 * La clave compuesta `[Contact_No+Grade]` es la consulta de la venta: «¿qué
 * lleva este grado de este colegio?». El índice suelto por `Contact_No` sirve
 * para listar los grados de un colegio en el selector.
 */
const schemaV22 = {
  ...schemaV21,
  productosAdoptados: "++id, Contact_No, [Contact_No+Grade], Item_No, lastSynced",
};

db.version(22)
  .stores(schemaV22)
  .upgrade(() => {});

/**
 * Versión 23 - Configuración contable de Business Central (OData
 * `ConfContabilidad`), sólo Perú; ver confContabilidadSyncService. De ella sale
 * el importe del impuesto a las bolsas de plástico.
 *
 * Además se vuelve a leer el stock entero: `importaciones_getproductostock`
 * empezó a publicar `Plactic_Bag`, y la lectura es incremental, así que los
 * productos ya guardados no lo traerían hasta que cambiaran en BC. Con el
 * `Source_Counter` en 0 la próxima lectura de la tienda arranca de cero (ver
 * `getLastSourceCounterForLocation`) sin vaciar el catálogo mientras tanto.
 */
const schemaV23 = {
  ...schemaV22,
  confContabilidad: "++id, lastSynced",
};

db.version(23)
  .stores(schemaV23)
  .upgrade((tx) =>
    tx
      .table("products")
      .toCollection()
      .modify((product) => {
        product.Source_Counter = 0;
      })
  );

// Funciones helper para gestionar el lastSourceCode
export const getLastSourceCode = async (entity = "products") => {
  try {
    const metadata = await db.syncMetadata.where("entity").equals(entity).first();
    return metadata ? metadata.lastSourceCode : -1;
  } catch (error) {
    anotarError(entidadDeTabla(entity), "no se pudo leer la marca de lectura", error);
    return -1;
  }
};

export const setLastSourceCode = async (sourceCode, entity = "products") => {
  try {
    const metadata = await db.syncMetadata.where("entity").equals(entity).first();
    if (metadata) {
      await db.syncMetadata.update(metadata.id, {
        lastSourceCode: sourceCode,
        lastSyncDate: new Date(),
      });
    } else {
      await db.syncMetadata.add({
        entity: entity,
        lastSourceCode: sourceCode,
        lastSyncDate: new Date(),
      });
    }
  } catch (error) {
    anotarError(entidadDeTabla(entity), "no se pudo guardar la marca de lectura", error);
  }
};

// Función para actualizar el estado de sincronización de un modelo
export const updateSyncStatus = async (entity, success, totalRecords = 0, errorMessage = null) => {
  try {
    const metadata = await db.syncMetadata.where("entity").equals(entity).first();

    const updateData = {
      lastSyncDate: new Date(),
      syncStatus: success ? "success" : "error",
      totalRecords: success ? totalRecords : metadata?.totalRecords || 0,
      errorMessage: errorMessage,
    };

    if (success) {
      updateData.lastSuccessfulSync = new Date();
    }

    if (metadata) {
      await db.syncMetadata.update(metadata.id, updateData);
    } else {
      await db.syncMetadata.add({
        entity: entity,
        ...updateData,
      });
    }
  } catch (error) {
    anotarError(entidadDeTabla(entity), "no se pudo registrar el estado", error);
  }
};

// Función para obtener el estado de sincronización de todos los modelos
export const getAllSyncStatus = async (country) => {
  try {
    const allMetadata = await db.syncMetadata.toArray();

    // Definir todos los modelos disponibles
    const allModels = await getModels(country);

    // El conteo sale de la tabla, no de la bitácora.
    //
    // `syncMetadata` sólo lo escribe updateSyncStatus, y a ésa sólo la llama
    // executeWithRetry. Cualquier camino que pueble una tabla por fuera -- los
    // productos que se traen al abrir caja, por ejemplo -- dejaba la ficha
    // diciendo "Registros: 0" con miles de filas guardadas, y "Actualizar
    // estado" releía la misma bitácora vacía. Contar es barato: Dexie lo
    // resuelve por índice.
    const result = await Promise.all(
      allModels.map(async (model) => {
        const metadata = allMetadata.find((m) => m.entity === model.key);
        const registros = await getTableCount(model.key);

        return {
          ...model,
          lastSyncDate: metadata?.lastSyncDate || null,
          lastSuccessfulSync: metadata?.lastSuccessfulSync || null,
          totalRecords: registros,
          // Si hay datos pero nadie anotó la sincronización, el estado honesto
          // no es "nunca": los registros están ahí.
          syncStatus: metadata?.syncStatus || (registros > 0 ? "success" : "never"),
          errorMessage: metadata?.errorMessage || null,
        };
      })
    );

    return result;
  } catch (error) {
    anotarErrorDeProceso("no se pudo leer el estado de sincronización", error);
    return [];
  }
};

// Función para obtener el conteo de registros de una tabla
export const getTableCount = async (tableName) => {
  try {
    if (db[tableName]) {
      return await db[tableName].count();
    }
    return 0;
  } catch (error) {
    anotarError(entidadDeTabla(tableName), "no se pudieron contar los registros", error);
    return 0;
  }
};

// Función para borrar todos los maestros
export const clearAllMasterData = async () => {
  try {
    anotarProceso("limpieza de maestros · inicio");

    // Definir las tablas de maestros a limpiar
    const masterTables = [
      "clients",
      "products",
      "productLines",
      "colegios",
      "tpvs",
      "turnos",
      "cajas",
      "coupons",
      "couponSalesPrices",
      "couponLineDiscounts",
      "couponDetails",
      "campaigns",
      "salesPrices",
      "grupoIVA",
      "formasPago",
      "empresa",
      "users", // Incluir usuarios excepto el actual
      "companies",
      "vendedores",
      "ciudades",
      "distritos",
      "departamentos",
      "gruposPrecioCliente",
      "gruposDtoCliente",
      "grupoCajeros",
      "puestos",
      "divisas",
      "formasPagoPorTienda",
      "serieNCF",
      "grupoPrecios",
      "productosAdoptados",
      "confContabilidad",
    ];

    // Obtener el usuario actual para no borrarlo. La sesión vive en la cookie
    // "user" (ver AuthContext), no en localStorage: leyéndolo de localStorage
    // siempre salía vacío y la tabla users se borraba completa, incluido el
    // usuario en sesión. Al repoblarse desde BC volvía con un id local nuevo y
    // la cookie quedaba apuntando a un registro inexistente ("Usuario no
    // encontrado" al cambiar la contraseña en Mi perfil).
    let currentUser = {};
    try {
      currentUser = JSON.parse(Cookies.get("user") || "{}");
    } catch (error) {
      anotarErrorDeProceso("no se pudo leer el usuario en sesión", error);
    }
    anotarProceso(`limpieza de maestros · se conserva el usuario ${currentUser.No || "(sin No)"}`);

    // Limpiar cada tabla de maestros
    const results = {};

    for (const tableName of masterTables) {
      try {
        if (tableName === "users" && currentUser.id) {
          // Para usuarios, borrar todos excepto el actual. Se filtra por el No
          // de BC cuando existe (el id local puede haber cambiado) y se cae al
          // id local solo como respaldo.
          const preserved = currentUser.No
            ? await db[tableName].where("No").equals(currentUser.No).first()
            : null;
          const preservedId = preserved?.id ?? currentUser.id;

          const deletedCount = await db[tableName].where("id").notEqual(preservedId).delete();
          results[tableName] = deletedCount;
        } else {
          // Para otras tablas, contar primero y luego borrar todo
          const countBeforeDelete = await db[tableName].count();
          await db[tableName].clear();
          results[tableName] = countBeforeDelete;
        }
      } catch (error) {
        anotarError(entidadDeTabla(tableName), "no se pudo limpiar", error);
        results[tableName] = `Error: ${error.message}`;
      }
    }

    // Resetear metadata de sincronización
    try {
      await db.syncMetadata.clear();

      // Recrear metadata básica
      await db.syncMetadata.add({
        entity: "products",
        lastSourceCode: -1,
        lastSyncDate: null,
      });
    } catch (error) {
      anotarErrorDeProceso("no se pudieron reiniciar las marcas de lectura", error);
    }

    // Calcular totales
    const totalDeleted = Object.values(results)
      .filter((count) => typeof count === "number")
      .reduce((sum, count) => sum + count, 0);

    const tablesWithErrors = Object.entries(results)
      .filter(([table, result]) => typeof result === "string")
      .map(([table, error]) => `${table}: ${error}`);

    // Una sola línea de cierre en vez de una por tabla más dos de resumen.
    anotarProceso(`limpieza de maestros · ${totalDeleted} registros eliminados`);

    if (tablesWithErrors.length > 0) {
      anotarAvisoDeProceso(
        `limpieza de maestros · no se pudieron limpiar: ${tablesWithErrors.join(", ")}`
      );
    }

    return {
      success: true,
      results: results,
      totalDeleted: totalDeleted,
      tablesWithErrors: tablesWithErrors,
      message: `Todos los maestros han sido eliminados correctamente. Total: ${totalDeleted} registros.`,
    };
  } catch (error) {
    anotarErrorDeProceso("la limpieza de maestros se interrumpió", error);
    return {
      success: false,
      error: error.message,
      message: "Error durante la limpieza de maestros",
    };
  }
};

// El descuento de la línea se guarda con dos decimales y **sin acercarlo al
// entero**. Antes pasaba por `roundWithTolerance`, igual que el IVA, y eso
// convierte en entero cualquier valor a 0,08 o menos de él: un 30,92 % tecleado
// por el cajero se guardaba como 31 %. La pantalla seguía mostrando 30,92 --es
// el estado del formulario, no la base--, pero el detalle de la factura y
// Business Central recibían 31 %, y el total cambiaba. Medido en PER TEST el
// 29/10/2026: la boleta VFAC18-01124313 dio S/ 81,52 en la pantalla y S/ 81,42
// en BC. Dos decimales es la regla de los porcentajes (DECIMALES_DE_PORCENTAJE
// en utils/decimalesDelImporte.js; no se importa aquí para no traer a la base
// el servicio de impresión que ese módulo carga).
//
// El IVA sí conserva la tolerancia: es un dato del producto, no algo que se
// teclea, y un 17,999 que llega de un cálculo tiene que leerse como 18.
const DECIMALES_DEL_DESCUENTO = 2;
export const descuentoDeLineaParaGuardar = (valor) =>
  roundDecimals(Number(valor ?? 0), DECIMALES_DEL_DESCUENTO);

// Hook para guardar formateado con tolerancia numeros
db.invoiceLines.hook("reading", (line) => {
  const format = (val) => roundWithTolerance(Number(val ?? 0));
  return {
    ...line,
    Line_Discount_: descuentoDeLineaParaGuardar(line.Line_Discount_),
    Line_Amount: roundDecimals(line.Line_Amount),
    PorIva: format(line.PorIva),
    Total_VAT_Amount: roundDecimals(line.Total_VAT_Amount),
    // null cuando la línea no vino de Business Central: es la marca de que no
    // hay importe suyo que respetar, y roundDecimals la convertiría en un 0
    // que sí parece un importe.
    Amount_Including_VAT:
      line.Amount_Including_VAT == null ? null : roundDecimals(line.Amount_Including_VAT),
  };
});

db.invoiceLines.hook("creating", (primKey, obj) => {
  const format = (val) => roundWithTolerance(Number(val ?? 0));
  obj.Line_Discount_ = descuentoDeLineaParaGuardar(obj.Line_Discount_);
  obj.Line_Amount = roundDecimals(obj.Line_Amount);
  obj.PorIva = format(obj.PorIva);
  obj.Total_VAT_Amount = roundDecimals(obj.Total_VAT_Amount);
  // Mismo criterio que en el hook de lectura: null se conserva.
  if (obj.Amount_Including_VAT != null)
    obj.Amount_Including_VAT = roundDecimals(obj.Amount_Including_VAT);
});

export default db;
